import BarChartHabilities from "../bar-chart";
import { TitleSection } from "../title-section";
import BarChart from "./bar-chart";

export const HabilitiesAndCompetences = () => {
  const array = [
    {
      titulo: "Competência 1",
      descricao:
        " Compreender os elementos culturais que constituem as identidades",
    },
    {
      titulo: "Competência 2",
      descricao: "Compreender as transformações dos espaços geográficos",
    },
    {
      titulo: "Competência 3",
      descricao:
        "Compreender a produção e organização dos espaços urbanos e rurais",
    },
    {
      titulo: "Competência 4",
      descricao: "Compreender as transformações e os processos históricos",
    },
    {
      titulo: "Competência 5",
      descricao:
        "Utilizar conceitos das Ciências Humanas na interpretação da realidade",
    },
    {
      titulo: "Competência 6",
      descricao:
        "Compreender a sociedade e a natureza, reconhecendo suas interações no espaço em diferentes contextos históricos e geográficos.",
    },
  ];

  return (
    <>
      <section
        id="habilidades"
        className="py-10 mx-4 lg:mx-0 flex justify-center"
      >
        <div className="flex flex-col items-center justify-center w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl space-y-10">
          {/* Título e descrição */}
          <TitleSection
            blueToRed
            first_title="Competências"
            second_tilte="e Hablidades"
            description="Todos os anos, as provas de Ciências Humanas do ENEM seguem um padrão de competências e habilidades exigidas. No Enem, competências são os saberes que devem ser dominados, e habilidades são a capacidade de aplicar esses saberes. A área de Ciências Humanas é composta de seis competências e trinta habilidades. Apresentamos agora as recorrências destas Competências e Habilidades nas provas do ENEM de 2009 até 2023."
          />

          {/* Seção com gráfico e tópicos */}
          <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
            {/* Gráfico */}
            {/* <div className="w-full md:w-1/2 shadow-lg"> */}
            {/* <div className="p-6">
                <h2 className="text-lg font-semibold">Bar Chart - Custom Label</h2>
                <p className="text-gray-500 text-sm">January - June 2024</p> */}

            {/* Aqui pode ser integrado um gráfico real usando alguma biblioteca como Recharts */}
            {/* <div className="mt-4 space-y-2">
                  <div className="flex justify-between">
                    <span className="text-blue-600">January</span>
                    <span className="font-medium">186</span>
                  </div>
                  <div className="h-3 bg-blue-500 rounded-md w-[80%]" />
                  
                  <div className="flex justify-between mt-2">
                    <span className="text-blue-600">February</span>
                    <span className="font-medium">305</span>
                  </div>
                  <div className="h-3 bg-blue-500 rounded-md w-[95%]" />

                  <div className="flex justify-between mt-2">
                    <span className="text-blue-600">March</span>
                    <span className="font-medium">237</span>
                  </div>
                  <div className="h-3 bg-blue-500 rounded-md w-[75%]" />
                </div>
              </div> */}
            <BarChart />
            {/* </div> */}

            {/* Lista de tópicos */}
            <div className="flex flex-col space-y-10 md:w-1/2">
              {array.map((texto, index) => (
                <p key={index} className="text-sm md:text-base text-gray-700">
                  <span className="text-blue-500 font-semibold">
                    {texto.titulo}:
                  </span>{" "}
                  {texto.descricao}
                </p>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className="flex flex-col items-center flex-1 justify-center mx-4 py-10">
        <TitleSection
          blueToRed={false}
          first_title="Sobre as"
          second_tilte="30 habilidades"
        ></TitleSection>
        <div className="flex w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl space-y-10">
          <BarChartHabilities title="Habilidades por competência" />
        </div>
      </div>
    </>
  );
};
